import { RouteComponentProps, withRouter } from 'react-router-dom';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import * as React from 'react'
import { inject, observer } from 'mobx-react';
import { Drawer, Grid, AppBar, Toolbar, IconButton, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, Tooltip } from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import AddIcon from '@material-ui/icons/Add';
import Objednavka from 'src/models/Objednavka';
import moment from 'moment'
import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';

export interface IWebOrderProps extends RouteComponentProps<any> {
    objednavkaStore?: ObjednavkaStore;
    turnusStore?: TurnusStore;
    klientStore?: KlientStore;
}

@inject('objednavkaStore')
@inject('turnusStore')
@inject('klientStore')
@observer
class WebOrders extends React.Component<IWebOrderProps>{

    constructor(props: Readonly<IWebOrderProps>) {
        super(props);
        console.log("LOAD: WebOrders");
    }

    @observable private isDrawerOpened: boolean = false;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private handleOrderClick = order => evt => {
        this.props.history.push(`/web-orders/${order.id}`)
    }

    public render() {
        return (
            <div>
                <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                    <NavigationDrawerItems />
                </Drawer>

                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <AppBar position="static" >
                            <Toolbar>
                                <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                    <MenuIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit"  style={{ flexGrow: 1 }}>
                                    Webové objednávky
                                </Typography>
                            </Toolbar>
                        </AppBar>
                    </Grid>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <Paper>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Datum</TableCell>
                                        <TableCell>Jméno</TableCell>
                                        <TableCell>Příjmení</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Telefon</TableCell>
                                        <TableCell>Ulice</TableCell>
                                        <TableCell>Město</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.props.objednavkaStore.webObjednavky.map(order => (
                                            <TableRow hover key={order.id} onClick={this.handleOrderClick(order)}>
                                                <TableCell>{order.datum.toLocaleDateString()}</TableCell>
                                                <TableCell>{order.jmeno}</TableCell>
                                                <TableCell>{order.prijmeni}</TableCell>
                                                <TableCell>{order.email}</TableCell>
                                                <TableCell>{order.telefon}</TableCell>
                                                <TableCell>{order.ulice}</TableCell>
                                                <TableCell>{order.mesto}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withRouter(WebOrders);


// WEBPACK FOOTER //
// ./src/components/WebOrders.tsx